import { useInfiniteQuery, UseInfiniteQueryOptions } from 'react-query';
import { isEmpty } from 'lodash';
import { LiveEventType } from 'api-data-types';
import moment from 'moment';
import requester from 'utils/requester';
import api from 'config/api';

const key = 'EPG';

type PageParamType = {
  startTime?: string;
  endTime?: string;
};

const DEFAULT_OPTIONS = {
  getNextPageParam: (lastPage) => {
    if (isEmpty(lastPage.data)) return;

    const startTime = lastPage.endTime;
    const endTime = moment(startTime).endOf('day').add(2, 'days').toISOString();
    return { startTime, endTime };
  },
  getPreviousPageParam: (firstPage) => {
    if (isEmpty(firstPage.data)) return;
    const endTime = firstPage.startTime;
    const startTime = moment(endTime).startOf('day').subtract(2, 'days').toISOString();
    return { startTime, endTime };
  },
};

type ResultType = {
  data: LiveEventType[];
  startTime: string;
  endTime: string;
};

const load = async (channelId: number, pageParam: PageParamType) => {
  let startTime = pageParam?.startTime;
  let endTime = pageParam?.endTime;

  if (!startTime) startTime = moment().startOf('day').subtract(2, 'days').toISOString();

  if (!endTime) endTime = moment().endOf('day').add(2, 'days').toISOString();

  const { data } = await requester({
    method: 'get',
    url: `${api.host}${api.endpoints.liveEvents}`,
    params: {
      'live.id[eq]': channelId,
      $expand: 'thumbnail(url),program,dvr,live',
      'start_time[gt]': startTime,
      'end_time[lt]': endTime,
    },
  });

  return { data, startTime, endTime };
};

const useLoadInfiniteEpg = (
  channelId: number,
  options: UseInfiniteQueryOptions<ResultType, unknown, ResultType> = {},
) => {
  return useInfiniteQuery<ResultType, Error>(
    [key, channelId],
    ({ pageParam }) => {
      return load(channelId, pageParam);
    },
    {
      ...DEFAULT_OPTIONS,
      ...options,
    },
  );
};

export default useLoadInfiniteEpg;
